export default "__VITE_ASSET__3IwZVTW0__"